module.exports = __webpack_public_path__ + "img/footer.a2fa104d.png";